export default __webpack_public_path__ + "static/media/yangyan-torrin-engagment-4.87899757.jpg";